import { api } from "@/lib/api";

const toPhotoFormData = (file) => {
  const form = new FormData();
  form.append("file", file);
  return form;
};

export const driverApi = {
  getProfile: () => api.get("/api/conductores/perfil"),
  upsertProfile: (payload) => api.put("/api/conductores/perfil", payload),
  uploadProfilePhoto: (file) => api.post("/api/conductores/perfil/foto", toPhotoFormData(file)),

  listVehicles: () => api.get("/api/conductores/vehiculos"),
  createVehicle: (payload) => api.post("/api/conductores/vehiculo", payload),
  updateVehicle: (id, payload) => api.put(`/api/conductores/vehiculo/${id}`, payload),
  activateVehicle: (id) => api.put(`/api/conductores/vehiculo/${id}/activar`),
  uploadVehiclePhoto: (id, file) => api.post(`/api/conductores/vehiculo/${id}/foto`, toPhotoFormData(file)),

  listRoutes: () => api.get("/api/conductores/rutas"),
  createRoute: (payload) => api.post("/api/conductores/rutas", payload),
  updateRoute: (id, payload) => api.put(`/api/conductores/rutas/${id}`, payload),
  deleteRoute: (id) => api.delete(`/api/conductores/rutas/${id}`),

  listSchedules: (routeId) => api.get(`/api/conductores/rutas/${routeId}/horarios`),
  createSchedule: (routeId, payload) => api.post(`/api/conductores/rutas/${routeId}/horarios`, payload),
  deactivateSchedule: (routeId, scheduleId) =>
    api.delete(`/api/conductores/rutas/${routeId}/horarios/${scheduleId}`),

  listDepartures: (routeId, params) => api.get(`/api/conductores/rutas/${routeId}/salidas`, { params }),
  cancelDeparture: (departureId) => api.put(`/api/conductores/salidas/${departureId}/cancelar`),
  getDepartureRoute: (departureId) => api.get(`/api/conductores/salidas/${departureId}/ruta`),

  listReservations: () => api.get("/api/conductores/reservas"),
  updateReservationStatus: (id, statusValue) => api.put(`/api/conductores/reservas/${id}/estado`, { status: statusValue }),
  markReservationPaid: (id, paymentReference) =>
    api.put(`/api/conductores/reservas/${id}/pago`, { payment_reference: paymentReference || null }),
  createClientReview: (reservationId, payload) => api.post(`/api/conductores/reservas/${reservationId}/resena`, payload),

  getRatings: () => api.get("/api/conductores/calificaciones"),
};

export default driverApi;
